import React, { useEffect, useState } from 'react';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Pagination from 'components/Pagination';

import {
  Input,
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label
} from 'reactstrap';
import { Chip } from '@material-ui/core/';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style,
  individual_icon_header_style_callback
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';
import FlexIAService from '../service';
import getFlexIAType from '../utils/getFlexIAType';
import { ChipContainer } from 'views/Chat/styles';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import { useForm } from 'react-hook-form';
import ErrorModal from 'components/Modal/ErrorModal/ErrorModal';
import ModalConfirmationCopy from './components/modalConfirmationCopy';

const FlexIAList = () => {
  const history = useHistory();

  const [flexiaInfo, setFlexiaInfo] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showDisabled, setShowDisable] = useState(false);
  const [errorDetails, setErrorDetails] = useState({
    message: '',
    campaign: [],
    timeout: [],
    flexias: [],
    channels: []
  });
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  const { watch } = useForm();
  const [dataFlexIACopy, setDataFlexIACopy] = useState(null);
  const [openModalConfirmationCopy, setOpenModalConfirmationCopy] =
    useState(false);

  const handleGetFlexIA = (selectedPage = 1, search = '') => {
    setLoading(true);

    FlexIAService.getAllFlexia(selectedPage, 10, search, {
      showDisable: showDisabled
    })
      .then((response) => {
        setFlexiaInfo(
          response.data.result.map((flexia) => {
            return {
              ...flexia,
              type: getFlexIAType(flexia.type || '')
            };
          })
        );
        setQuantity(response.data.count);
      })
      .catch((err) => {
        toast.error(
          (err.response && err.response.data.message) ||
            'Erro ao listar configurações da FlexIA!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      })
      .finally(setLoading(false));
  };

  useEffect(() => {
    handleGetFlexIA();
  }, []);

  useEffect(() => {
    handleGetFlexIA();
    setActivePage(1);
  }, [showDisabled]);

  const getFlexIASearch = (event) => {
    handleGetFlexIA(1, event.target.value);
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    handleGetFlexIA(page);
  };

  const controlDelete = (id) => {
    FlexIAService.deleteFlexiaById(id)
      .then(() => {
        toast.info('Configuração FlexIA excluída!', {
          autoClose: 3000,
          closeOnClick: true
        });
        handleGetFlexIA(activePage);
      })
      .catch((err) => {
        toast.error(err.response.data.msg || 'Ops, algo errado aconteceu!', {
          autoClose: 3000,
          closeOnClick: true
        });
        if (err?.response?.data.usageFlexia) {
          setErrorDetails({
            message: err.response.data.msg,
            campaign: err.response.data.usageFlexia.campaign,
            timeout: err.response.data.usageFlexia.timeout,
            flexias: err.response.data.usageFlexia.flexias,
            channels: err.response.data.usageFlexia.channels
          });
          setErrorModalOpen(true);
        }
      });
  };

  const toggleDisable = (id, status) => {
    const showDisableActual = watch('showDisabled');
    const newStatus = !status;

    FlexIAService.enableFlexiaById(id, newStatus)
      .then((res) => {
        if (res.data.msg) {
          if (!showDisableActual && newStatus === true) {
            setFlexiaInfo((prevFlexias) =>
              prevFlexias.filter((flexia) => flexia.id !== id)
            );
          } else {
            setFlexiaInfo((prevFlexias) =>
              prevFlexias.map((flexia) =>
                flexia.id === id
                  ? { ...flexia, disable: !flexia.disable }
                  : flexia
              )
            );
          }
          const message = !newStatus ? 'Habilitada' : 'Desabilitada';
          toast.success(
            `Alteração realizada com sucesso, flexIA agora está ${message}`,
            {
              autoClose: 3000,
              closeOnClick: true
            }
          );
        }
      })
      .catch((err) => {
        toast.error('Erro ao alterar status da flexIA ', {
          autoClose: 3000,
          closeOnClick: true
        });
        if (err?.response?.data.usageFlexia) {
          setErrorDetails({
            message: err.response.data.msg,
            campaign: err.response.data.usageFlexia.campaign,
            timeout: err.response.data.usageFlexia.timeout,
            flexias: err.response.data.usageFlexia.flexias,
            channels: err.response.data.usageFlexia.channels
          });
          setErrorModalOpen(true);
        }
        setFlexiaInfo((prevFlexias) => prevFlexias);
      });
  };

  async function handleCloneFlexIA(flexiaId) {
    try {
      const response = await FlexIAService.getFlexiaById(flexiaId);
      const data = response.data.data;
      setDataFlexIACopy(data);
      setOpenModalConfirmationCopy(true);
    } catch (err) {
      toast.error('Erro ao tentar pegar os dados da FlexIA para clonagem.', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  }

  return (
    <>
      <SimpleHeader
        setCreate="/admin/flexia/form"
        name="Form validation"
        parentName="Forms"
      />

      <ErrorModal
        isOpen={errorModalOpen}
        toggle={() => setErrorModalOpen(false)}
        message={errorDetails.message}
        entityName="FlexIA"
        associations={{
          campanhas: errorDetails.campaign,
          ociosidades: errorDetails.timeout,
          flexias: errorDetails.flexias,
          canais: errorDetails.channels
        }}
      />

      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>FlexIA</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Pesquisar por nome"
                          type="text"
                          onChange={(event) => getFlexIASearch(event)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md="4" className="text-right mt-2 mt-md-1">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={showDisabled}
                            onChange={() => setShowDisable(!showDisabled)}
                          />
                          <span>Mostrar desabilitados</span>
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={flexiaInfo || []}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'description',
                      text: 'Descrição',
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'type',
                      text: 'Tipo',
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'disable',
                      text: 'Ativo',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      formatter: (_, row) => {
                        return (
                          <ChipContainer>
                            {row.disable === false ? (
                              <Chip
                                className="chipTrue"
                                size="small"
                                label="sim"
                              />
                            ) : (
                              <Chip
                                className="chipFalse"
                                size="small"
                                label="não"
                              />
                            )}
                          </ChipContainer>
                        );
                      }
                    },
                    {
                      dataField: 'disable',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style_callback,
                      text: 'Desabilitar / Habilitar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <ToggleSwitch
                            checked={!row.disable}
                            id={row.id}
                            onChange={() => {
                              toggleDisable(row.id, row.disable);
                            }}
                          />
                        );
                      }
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            disabled={row.disable}
                            onClick={() =>
                              history.push(`flexia/form/${row.id}`)
                            }
                          >
                            <li className="fas fa-edit"></li>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="danger"
                            title="Deletar"
                            size="sm"
                            onClick={() => {
                              window.confirm(
                                'Deseja realmente excluir essa FlexIA?'
                              ) && controlDelete(row.id);
                            }}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'clone',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Clonar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            title={'Clonar FlexIA'}
                            onClick={() => handleCloneFlexIA(row.id)}
                          >
                            <li className="fas fa-clone"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>

      <ModalConfirmationCopy
        isModalOpen={openModalConfirmationCopy}
        onModalToggle={setOpenModalConfirmationCopy}
        unmountOnClose={true}
        flexIACopy={dataFlexIACopy}
        handleGetFlexIA={handleGetFlexIA}
        activePage={activePage}
      />
    </>
  );
};

export default FlexIAList;
